// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/c010fd5ea69964c7ef01.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"35f2f1ca3aaa07273e92","159":"92294f7fd59977bbc108","160":"137e88dccfc25b9cc9d2"}[chunkId] + ".chunk.js";
};